export const showreel = {
  videoSrc: 'https://cdn.magicpatterns.com/uploads/tFdCp9VQ7JnYe9xJWrSQ83/showreel-short-preview-1-transcode.webm',
};
